import { UseCase } from '@/core/base/use-case';
import { LocationsRepository } from '../repositories/locations.respository';
import { Observable } from 'rxjs';
import { LocationResponse } from '../models/location-response.model';
import { LocationRequest } from '../models/location-request.model';

export class FindLocationsUseCase
    implements UseCase<LocationRequest, LocationResponse>
{
    constructor(private readonly repository: LocationsRepository) {}

    execute(locationRequest: LocationRequest): Observable<LocationResponse> {
        return this.repository.findLocations(locationRequest);
    }
}
